import { Field } from 'react-jeff'
import { omit } from 'lodash'

export type ToggleSet = Record<string, true>

const set = (set: ToggleSet, key: string, value: boolean): ToggleSet => {
  return value ? { ...set, [key]: true } : omit(set, key)
}

export const useFormToggleSet = <T>(field: Field<ToggleSet>) => {
  return {
    value: field.value,
    toggleHandler: (key: string) => () =>
      field.props.onChange(set(field.value, key, !field.value[key])),
  }
}
